import { CollisionDescriptorType, CollisionDescriptorUsageType } from '../../interfaces/GenericInterfaces';
import { TransformationDataDTO } from './TransformationDataDTO';

export class CollisionDescriptorDTO {
  id?: number;
  type: CollisionDescriptorType;
  usageTypes: CollisionDescriptorUsageType[];

  constructor(
    id: number | undefined,
    type: CollisionDescriptorType,
    usageTypes: CollisionDescriptorUsageType[] = [CollisionDescriptorUsageType.DEFAULT],
  ) {
    this.id = id;
    this.type = type;
    this.usageTypes = usageTypes;
  }
}

export class OBBCollisionDescriptorDTO extends CollisionDescriptorDTO {
  transformationData: TransformationDataDTO;
  halfSize: number[];

  constructor(
    id: number,
    type: CollisionDescriptorType,
    transformationData: TransformationDataDTO,
    halfSize: number[],
  ) {
    super(id, type);
    this.transformationData = transformationData;
    this.halfSize = halfSize;
  }
}
